import { createFileRoute } from '@tanstack/react-router'
import { BuyersPage } from '@/features/operations'
import { requireRole } from '@/lib/auth-guards'

export const Route = createFileRoute('/_authenticated/targets/')({
  component: BuyersPage,
  beforeLoad: requireRole(['admin']),
})
